// AppContent.js
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSwal } from "../../services/SweetAlert";
import useIdleTimer from "../../services/idealTimeout/useIdleTimer";
import useAxiosInterceptor from "../../services/axios/useAxiosInstance";
import api from "../../services/axios";
import NavRouting from "../../component/NavRouting";
import { useAuth } from "../../context/AuthContext";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../../assest/css/style.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

function AppContent() {
  const [showModal, setShowModal] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { confirm } = useSwal();
  const { logout, isAuthenticated } = useAuth(); // ✅ Now safe
  useAxiosInterceptor();

  const handleIdle = () => {
    if (!["/", ""].includes(window.location.pathname)) {
      setShowModal(true);

      let timer;
      const autoLogoutPromise = new Promise((resolve) => {
        timer = setTimeout(() => resolve("auto-logout"), 60 * 1000);
      });

      const confirmPromise = confirm(
        "Due to inactivity, your session will expire in 60 seconds. Choose Yes to Logout or No to stay Logged In?",
        "Session Timeout",
        true
      );

      Promise.race([confirmPromise, autoLogoutPromise]).then((result) => {
        setShowModal(false);

        if (result === "auto-logout" || result === true) {
          handleLogout();
        } else {
          handleContinue();
        }

        clearTimeout(timer);
      });
    }
  };

  const handleLogout = () => {
    logout(); // ✅ use context logout
    navigate("/");
  };

  const handleContinue = () => setShowModal(false);

  /**
   * Send heartbeat
   */
  const sendHeartbeat = async () => {
    try {
      const res = await api.post("/user/heartbeat", {});
      if (res.status === 200) {
        console.log("✅ Heartbeat sent at", new Date().toLocaleTimeString());
      } else {
        console.error("❌ Heartbeat failed:", res.status);
      }
    } catch (error) {
      console.error("Error sending heartbeat:", error);
    }
  };

  /**
   * Run heartbeat every 30s (first time after 30s)
   */
  useEffect(() => {
    let intervalId;

    if (isAuthenticated && !["/", ""].includes(location.pathname)) {
      intervalId = setInterval(() => {
        sendHeartbeat();
      }, 30000);

      console.log("🔄 Heartbeat scheduling started (every 30s)");
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        console.log("🛑 Heartbeat stopped");
      }
    };
  }, [isAuthenticated, location.pathname]);

  // useIdleTimer({
  //   idleTime: process.env.REACT_APP_IDLE_LOGOUT_TIME * 60 * 1000,
  //   onIdle: handleIdle,
  // });

  return <NavRouting />;
}

export default AppContent;
